export default __webpack_public_path__ + "static/media/profilePic.a3f8de65.jpg";